/* eslint-disable import/prefer-default-export,quote-props */
export const COUNTRY_AND_STATE = {
  'United States': [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'VI',
    'WA',
    'WV',
    'WI',
    'WY',
    'AA',
    'AE',
    'AP',
  ],
  'Canada': [
    'AB',
    'BC',
    'MB',
    'NB',
    'NL',
    'NT',
    'NS',
    'NU',
    'ON',
    'PE',
    'QC',
    'SK',
    'YT',
  ],
};

export const COUNTRIES = {
  UNITED_STATES: 1,
  CANADA: 2
};

export const TIME_ZONE = [
  'America/Halifax',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
];

export const TIME_ZONE_RELATIONSHIP = [
  ['America/Halifax', 'Atlantic Standard Time'],
  ['America/New_York', 'Eastern Standard Time'],
  ['America/Chicago', 'Central Standard Time'],
  ['America/Denver', 'Mountain Standard Time'],
  ['America/Phoenix', 'Mountain Standard Time (Arizona)'],
  ['America/Los_Angeles', 'Pacific Standard Time'],
  ['America/Anchorage', 'Alaska Standard Time'],
  ['Pacific/Honolulu', 'Hawaii Standard Time'],
];

// This one removes "Standard", which can be NOT true during summer "Daylight Saving Time".
export const TIME_ZONE_RELATIONSHIP_GENERIC = [
  ['America/Halifax', 'Atlantic Time'],
  ['America/New_York', 'Eastern Time'],
  ['America/Chicago', 'Central Time'],
  ['America/Denver', 'Mountain Time'],
  ['America/Phoenix', 'Mountain Time (Arizona)'],
  ['America/Los_Angeles', 'Pacific Time'],
  ['America/Anchorage', 'Alaska Time'],
  ['Pacific/Honolulu', 'Hawaii Time'],
];

export const TIME_ZONE_RELATIONSHIP_ABBREVIATED = [
  ['America/Halifax', 'AT'],
  ['America/New_York', 'ET'],
  ['America/Chicago', 'CT'],
  ['America/Denver', 'MT'],
  ['America/Phoenix', 'AZ'],
  ['America/Los_Angeles', 'PT'],
  ['America/Anchorage', 'AK'],
  ['Pacific/Honolulu', 'HI'],
];

// src/constants/formOptions.js

/**
 * A more global map of IANA zone → friendly label, for showing the
 * user’s *browser* time zone. Fallback in your code to the raw IANA
 * string if there’s no match here.
 */
export const BROWSER_TIME_ZONE_RELATIONSHIP_GENERIC = [
  // North America
  ['Pacific/Honolulu', 'Hawaii Time'],
  ['America/Anchorage', 'Alaska Time'],
  ['America/Los_Angeles', 'Pacific Time'],
  ['America/Denver', 'Mountain Time'],
  ['America/Phoenix', 'Mountain Time (Arizona)'],
  ['America/Chicago', 'Central Time'],
  ['America/New_York', 'Eastern Time'],
  ['America/Indiana/Indianapolis', 'Eastern Time'],
  ['America/Indianapolis', 'Eastern Time'],
  ['America/Halifax', 'Atlantic Time'],
  ['America/St_Johns', 'Newfoundland Time'],

  // South America
  ['America/Sao_Paulo', 'Brasília Time'],
  ['America/Argentina/Buenos_Aires', 'Argentina Time'],

  // Europe
  ['Europe/London', 'Greenwich Mean Time'],
  ['Europe/Dublin', 'Greenwich Mean Time'],
  ['Europe/Berlin', 'Central European Time'],
  ['Europe/Paris', 'Central European Time'],
  ['Europe/Moscow', 'Moscow Time'],

  // Middle East
  ['Asia/Dubai', 'Gulf Standard Time'],
  ['Asia/Jerusalem', 'Israel Standard Time'],

  // South Asia
  ['Asia/Kolkata', 'India Standard Time'],

  // East & Southeast Asia
  ['Asia/Shanghai', 'China Standard Time'],
  ['Asia/Singapore', 'Singapore Time'],
  ['Asia/Tokyo', 'Japan Standard Time'],
  ['Asia/Seoul', 'Korea Standard Time'],

  // Oceania
  ['Australia/Adelaide', 'Australian Central Time'],
  ['Australia/Sydney', 'Australian Eastern Time'],
  ['Pacific/Auckland', 'New Zealand Standard Time']
];

export const BROWSER_TIME_ZONE_RELATIONSHIP_ABBREVIATED = [
  // North America
  ['Pacific/Honolulu', 'HT'],
  ['America/Anchorage', 'AKT'],
  ['America/Los_Angeles', 'PT'],
  ['America/Denver', 'MT'],
  ['America/Phoenix', 'MST'],
  ['America/Chicago', 'CT'],
  ['America/New_York', 'ET'],
  ['America/Indiana/Indianapolis', 'ET'],
  ['America/Indianapolis', 'ET'],
  ['America/Halifax', 'AT'],
  ['America/St_Johns', 'NT'],

  // South America
  ['America/Sao_Paulo', 'BRT'],
  ['America/Argentina/Buenos_Aires', 'ART'],

  // Europe
  ['Europe/London', 'GMT'],
  ['Europe/Dublin', 'GMT'],
  ['Europe/Berlin', 'CET'],
  ['Europe/Paris', 'CET'],
  ['Europe/Moscow', 'MSK'],

  // Middle East
  ['Asia/Dubai', 'GST'],
  ['Asia/Jerusalem', 'IST'],

  // South Asia
  ['Asia/Kolkata', 'IST'],

  // East & SE Asia
  ['Asia/Shanghai', 'CST'],
  ['Asia/Singapore', 'SGT'],
  ['Asia/Tokyo', 'JST'],
  ['Asia/Seoul', 'KST'],

  // Oceania
  ['Australia/Adelaide', 'ACST'],
  ['Australia/Sydney', 'AEST'],
  ['Pacific/Auckland', 'NZST']
];

export const DEFAULT_FLAGS_OPTIONS = [
  {
    id: 'Y',
    name: 'Yes'
  },
  {
    id: 'N',
    name: 'No'
  },
  {
    id: 'M',
    name: 'Maybe'
  },
];
